<template>
  <div>
    <el-dialog
      title="全电票验证"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
      v-loading="loading"
    >
      <el-button size="mini" @click="getSmsCode"> 获取短信验证码 </el-button>
      <el-button size="mini" @click="validateSms"> 验证短信是否发送 </el-button>
      <el-button size="mini" @click="getRiskStatus"> 查询风险状态 </el-button>
      <el-button size="mini" @click="getAuthQrcode">
        获取人脸识别二维码
      </el-button>
      <el-button size="mini" @click="getAuthResult">
        获取人脸识别结果
      </el-button>
      <div v-if="this.qrcodeUrl.length > 0" style="display: block">
        <span style="display: block; margin-top: px">
          请使用电子税务局app扫码（5分钟内有效）
        </span>
        <el-image :src="this.qrcodeUrl" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import imgurl from "@/assets/js/imgurl.js";
export default {
  name: "invoiceDigitization",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    discId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      qrcodeUrl: "",
    };
  },
  methods: {
    handleClose() {
      this.qrcodeUrl = "";
      this.$emit("close", false);
    },
    getSmsCode() {
      this.$myhttp
        .post(
          "admin/InvoiceDisc/getSmsCode",
          { id: this.discId },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    validateSms() {
      this.$myhttp
        .post(
          "admin/InvoiceDisc/validSmsStatus",
          { id: this.discId },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    getRiskStatus() {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/InvoiceDisc/getRiskStatus",
          { id: this.discId },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          this.loading = false;
          if (backdata.data.code == 200) {
            this.$alert(backdata.data.msg, "风险状态", {
              confirmButtonText: "确定",
              dangerouslyUseHTMLString: true,
            });
          } else {
            this.loading = false;
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    getAuthQrcode() {
      this.$prompt("请输入验证码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.loading = true;
          this.$myhttp
            .post(
              "admin/InvoiceDisc/getAuthQrcode",
              { id: this.discId, code: value },
              {
                "Content-Type": "application/json",
              }
            )
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.loading = false;
                this.qrcodeUrl = imgurl + backdata.data.data.url;
              } else {
                this.loading = false;
                this.$message.error(backdata.data.msg);
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    getAuthResult() {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/InvoiceDisc/getAuthResult",
          { id: this.discId },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          this.loading = false;
          if (backdata.data.code == 200) {
            this.$alert(backdata.data.msg, "识别结果", {
              confirmButtonText: "确定",
              dangerouslyUseHTMLString: true,
            });
          } else {
            this.loading = false;
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Admin/Finance/invoiceDigitization.vue